import ReactDOMServer from 'react-dom/server';
import { Typography } from '@mui/material';
import { Icon } from '../../blocks/icons';
import { getFormattedDate } from '.';

const tooltipHelpers = {
	/**
	 * Builds tooltip markup for client permissions tooltip
	 *
	 * @param { object } clientUser a string containing an organization name
	 * @param { boolean } clientUser.plannerOrgHasConnectionPermissions
	 * @param { boolean } clientUser.plannerOrgCanSignContracts
	 * @param { boolean } clientUser.plannerOrgCanPayInvoices
	 * @param { boolean } clientUser.plannerOrgHasDocumentsPermissions
	 * @param { boolean } self whether viewing for self or others
	 *
	 * @returns { <string|null> }
	 */
	buildClientPermissionsToolTip: ( clientUser, currentUser ) => {
		let orgUser = null;
		if ( currentUser?.user?.userType === 'OrgUser' ) {
			orgUser = currentUser;
		}

		const iconMarkup = ( permission, clientUser ) => {
			return (
				<div className='icon-container'>
					{ clientUser[ permission ] ? (
						<div className='icon--check'>
							<Icon className='icon--check' type={ 'check' } />
						</div>
					) : (
						<div className='icon--cross'>
							<Icon type={ 'cross' } />
						</div>
					) }
				</div>
			);
		};

		// Client permissions modal
		const permissionsString = ReactDOMServer.renderToString(
			<div className='tooltip-container'>
				<Typography className='p--bold'>Permissions granted</Typography>
				<Typography>
					{ ' ' }
					{ orgUser ? 'Your organization' : 'This vendor' } can
				</Typography>
				<div className='permission-item permission-item__connection'>
					{ iconMarkup( 'plannerOrgHasConnectionPermissions', clientUser ) }
					<Typography>invite vendors + approve docs</Typography>
					<br />
				</div>
				<div className='permission-item permission-item__contract'>
					{ iconMarkup( 'plannerOrgCanSignContracts', clientUser ) }
					<Typography>
						sign contracts on { orgUser ? 'their' : 'your' } behalf
					</Typography>
					<br />
				</div>
				<div className='permission-item permission-item__invoice'>
					{ iconMarkup( 'plannerOrgCanPayInvoices', clientUser ) }
					<Typography>
						pay invoices on { orgUser ? 'their' : 'your' } behalf
					</Typography>
					<br />
				</div>
				<div className='permission-item permission-item__document'>
					{ iconMarkup( 'plannerOrgHasDocumentsPermissions', clientUser ) }
					<Typography>manage { orgUser ? 'their' : 'your' } folder</Typography>
					<br />
				</div>
			</div>
		);

		const noPermissionsString = ReactDOMServer.renderToString(
			<div className='permissions-tooltip-container'>
				<Typography>
					{ clientUser.firstNameOne + ' ' + clientUser.lastNameOne } has given
				</Typography>
				<Typography>this vendor permissions</Typography>
				<Typography>to act on their behalf.</Typography>
			</div>
		);

		if (
			!orgUser ||
			( clientUser.assignedPlanner.organization.id &&
				orgUser.organization.id === clientUser.assignedPlanner.organization.id )
		) {
			return permissionsString;
		} else {
			return noPermissionsString;
		}
	},

	/**
	 * Builds tooltip markup for event date differences tooltip.
	 *
	 * @param { string } contactFirstName - the first name on the contact.
	 * @param { string } weddingDate - a formatted string representing a date.
	 * @returns { <string|null> }
	 */
	buildEventDateDifferenceToolTip: ( contactFirstName, weddingDate ) => {
		return ReactDOMServer.renderToString(
			<div className='tooltip-container'>
				<Typography>
					{ contactFirstName } entered an event date of{ ' ' }
					{ getFormattedDate( weddingDate ) }
				</Typography>
			</div>
		);
	},

	/**
	 * Builds tooltip markup for client permissions tooltip
	 *
	 * @param { string | undefined | null } text a string to put into tooltip
	 *
	 * @returns { <string|null> }
	 */
	buildGenericToolTip: ( text ) => {
		return ReactDOMServer.renderToString(
			<div className='tooltip-container'>
				<Typography>{ text }</Typography>
			</div>
		);
	},
};

export default tooltipHelpers;
